// React
import { FC } from 'react'

// Libraries
import { Link } from 'gatsby-plugin-react-i18next'
import { useTranslation } from 'react-i18next'

// Custom
import {
  CompanyInfo,
  EmailSocialDiv,
  GoBack,
  LogoDiv,
  NavDiv,
  NavSection,
  SocialDiv,
  SectionOptions,
  SectionTitle,
  Wrapper,
} from './styled'
import {
  Logo,
  MinimalLogo,
  SocialIcon,
  SocialButton,
} from 'components/UI/Images'
import { PaddingContainer } from 'components/UI/Containers'
import { theme } from 'lib/styled-components/theme'
import { GENERAL } from 'locales'
import NavMenu from 'components/NavMenu'
import useMediaQuery from 'hooks/useMediaQuery'

// Constants
import { COMPANY, SOCIAL_ICONS, SOCIAL_MEDIA_LINKS } from 'data'


type Option = {
  label: string
  path: string
}

type Props = {
  navMobile?: Option[]
  navCompany?: Option[]
  navSolutions?: Option[]
  navLegal?: Option[]
}

const Footer: FC<Props> = (Props: Props) => {
  const {
    navMobile = [],
    navCompany = [],
    navSolutions = [],
    navLegal = [],
  } = Props

  const { t } = useTranslation()

  const isDesktop = useMediaQuery(
    `(min-width: ${theme.breakpoints.desktopMin}px)`,
  )

  const renderSocialButtons = () => {
    return SOCIAL_ICONS.map((socialMedia) => {
      return socialMedia.path === '#' ? null : (
        <SocialButton href={socialMedia.path} target="_blank" key={socialMedia.path}>
          <SocialIcon src={socialMedia.label} />
        </SocialButton>
      )
    })
  }

  const companyInfo = (
    <CompanyInfo>
      <p>{t(GENERAL.footer.caduProduct, { company: COMPANY.legalName })}</p>
      <p>{`CNPJ ${COMPANY.cnpj}`}</p>
      <p>{COMPANY.address}</p>
    </CompanyInfo>
  )

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <Wrapper>
      {isDesktop ? (
        <PaddingContainer>
          <EmailSocialDiv>
            <Link to="/">
              <LogoDiv>
                <MinimalLogo color="white" />
              </LogoDiv>
            </Link>
            {SOCIAL_MEDIA_LINKS.email}
            <SocialDiv>{renderSocialButtons()}</SocialDiv>
            {companyInfo}
          </EmailSocialDiv>
          <NavDiv>
            <NavSection>
              <SectionTitle>Company</SectionTitle>
              <SectionOptions data-testid="navbar">
                <NavMenu navOptions={navCompany} footer={true} />
              </SectionOptions>
            </NavSection>
            <NavSection>
              {/* <SectionTitle>Solutions</SectionTitle>
              <SectionOptions data-testid="navbar">
                <NavMenu navOptions={navSolutions} footer={true} />
              </SectionOptions> */}
            </NavSection>
            <NavSection>
              <SectionTitle></SectionTitle>
              <SectionOptions data-testid="navbar">
                <NavMenu navOptions={navLegal} footer={true} />
              </SectionOptions>
            </NavSection>
          </NavDiv>
        </PaddingContainer>
      ) : (
        <PaddingContainer flex="column">
          <Link to="/">
            <Logo />
          </Link>
          <NavDiv data-testid="navbar">
            <NavMenu navOptions={navMobile} footer={true} />
          </NavDiv>
          {SOCIAL_MEDIA_LINKS.email}
          <SocialDiv>{renderSocialButtons()}</SocialDiv>
          {companyInfo}
          <GoBack onClick={scrollTop}>Voltar ao topo</GoBack>
        </PaddingContainer>
      )}
    </Wrapper>
  )
}

export default Footer
